module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAbCAYAAAD28DaZAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACXSURBVHgB7dXBDYAgDIXhjuAIjMBojtBNHcERnj1IYhQJILQe+iccPDT5DlCJDAMQ6A8JJMrZ5TBZdoGkmCzKQHB+L6RZARJJM4c4xCEOkQHGh7U8GpJiamwkZMUzbpgfd0dkKMjZekCYcVl7QJj5alpA0Hi+NSBo7pESSBVSAbLZrAWQLqQCpP+veQHZQDIgW8gNNBVyAF2kRAPIK4MMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/done.png
// module id = 1661
// module chunks = 0